import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import {SharedPipesModule} from '@shared/pipes/pipes.module';
import {DirectivesModule} from '@shared/directives/directives.module';
import {SharedModule} from '@shared/shared.module';
import {TeamRouting} from '@modules/team/team.routing';
import {TeamStartPageComponent} from '@modules/team/pages/team-start-page/team-start-page.component';
import {TeamNewsComponent} from '@modules/team/pages/team-news/team-news.component';
import {ClubTeamsComponent} from '@modules/team/pages/club-teams/club-teams.component';
import {TeamMatchesWrapperComponent} from '@modules/team/pages/team-matches/team-matches-wrapper.component';
import {TeamMatchesComponent} from '@modules/team/pages/team-matches/team-matches.component';
import {TeamNewsListComponent} from '@modules/team/pages/team-news-list/team-news-list.component';
import {TeamSquadComponent} from '@modules/team/pages/team-squad/team-squad.component';
import {TeamTableComponent} from '@modules/team/pages/team-table/team-table.component';
import { TeamSquadPlayersComponent } from './pages/team-squad/team-squad-players/team-squad-players.component';
import { TeamSquadTrainersComponent } from './pages/team-squad/team-squad-trainers/team-squad-trainers.component';
import {VotingModule} from '@modules/voting/voting.module';
import {SharedNewsModule} from '@shared/modules/shared-news/shared-news.module';
import {LibTableModule} from '@lib-modules/table/lib-table.module';
import { TeamVideosComponent } from './pages/team-videos/team-videos.component';
import {SharedVideosModule} from '@shared/modules/shared-videos/shared-videos.module';
import {SharedGamesModule} from '@shared/modules/shared-games/shared-games.module';
import {LibAdCampaignModule} from '@components/ad-campaign/lib-ad-campaign.module';
import {SharedNewsListModule} from '@shared/modules/shared-news-list/shared-news-list.module';
import {SharedNewsDetailModule} from '@shared/modules/shared-news-detail/shared-news-detail.module';
import {LibBettingGameModule} from '@components/betting-game/lib-betting-game.module';
import {SharedBannersModule} from '@shared/modules/shared-banners/shared-banners.module';
import { TeamTransfersComponent } from './pages/team-transfers/team-transfers.component';
import { LibGamesModule } from '@components/games/lib-games.module';
import {LibSectionModule} from '@lib-modules/section/lib-section.module';
import { TeamHomeComponent } from './pages/team-home/team-home.component';
import { TeamReplaysComponent } from './pages/team-replays/team-replays.component';
import { TeamLivestreamsComponent } from './pages/team-livestreams/team-livestreams.component';
import { TeamAboGuard } from './guards/team-abo.guard';

@NgModule({
  declarations: [
    TeamStartPageComponent,
    TeamNewsComponent,
    ClubTeamsComponent,
    TeamMatchesWrapperComponent,
    TeamMatchesComponent,
    TeamNewsListComponent,
    TeamSquadComponent,
    TeamTableComponent,
    TeamSquadPlayersComponent,
    TeamSquadTrainersComponent,
    TeamVideosComponent,
    TeamTransfersComponent,
    TeamHomeComponent,
    TeamReplaysComponent,
    TeamLivestreamsComponent,
  ],
  imports: [
    CommonModule,
    TeamRouting,
    SharedPipesModule,
    DirectivesModule,
    SharedModule,
    VotingModule,
    SharedVideosModule,
    SharedNewsModule,
    SharedNewsDetailModule,
    SharedNewsListModule,
    SharedGamesModule,
    LibGamesModule,
    LibTableModule,
    LibAdCampaignModule,
    LibBettingGameModule,
    SharedBannersModule,
    LibSectionModule
  ],
  providers: [
    TeamAboGuard,
  ]
})
export class TeamModule { }
